<template>
  <main class="bg_gray default-container-width relative">
    <div class="container-fluid">
      <BannerCarousel />

      <div class="dash_header">
        <IntroHeader
          :user-name="userName"
          :has-seo-score-feature="hasSeoScoreFeature"
          class="tailwind"
        />
        <DashboardMenu
          v-if="user && (user.permissions.dashboard_permission === 'EDIT')"
          class="tailwind"
          @edit-layout="enableEditing"
          @add-widget="openAddWidgetModal"
          @my-widgets="openMyWidgetsModal"
          @shareable-link="getSharableLink"
        />
      </div>

      <SeoScore v-if="hasSeoScoreFeature" />

      <div
        v-if="editing"
        class="editing_layout"
      >
        Editing Layout
        <button
          class="btn btn_sm primary_btn"
          @click="saveLayout()"
        >
          <span>
            <i
              v-if="saving"
              class="fa fa-btn fa-spinner fa-spin"
            />
            {{ saving ? 'Saving' : 'Save' }}
          </span>
        </button>
        <button
          class="btn btn_sm btn-danger"
          @click="cancelEditing()"
        >
          <span>
            Cancel
          </span>
        </button>
      </div>

      <CancellingWebsiteWarning
        v-if="showWebsiteCancellingWarning"
        :website-id="activeWebsite.hash_id"
        :end-date="websiteEndDateFormatted"
      />

      <gridstack-container
        :key="gridKey"
        :editing="editing"
      />
    </div>
  </main>
  <AddIndustry />
  <AcceptTermsModal
    v-if="showNewTerms"
    :current-tos-version="currentTosVersion"
  />
</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex';
import GridstackContainer from './components/GridstackContainer.vue'
import AddIndustry from "./components/modals/AddIndustry";
import AcceptTermsModal from "@/components/compliance/modals/AcceptTermsModal.vue";
import moment from 'moment';
import DashboardMenu from "@/components/dashboard/buttons/DashboardMenu.vue";
import useUser from "@/composables/useUser.js";
import IntroHeader from "./components/IntroHeader.vue";
import BannerCarousel from "@/components/banners/BannerCarousel.vue";

export default {
  components: {
    BannerCarousel,
    IntroHeader,
    DashboardMenu,
    AddIndustry,
    GridstackContainer,
    AcceptTermsModal,
  },
  props: {
    whitelabel: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const { hasSeoScoreFeature } = useUser();

    return {
      hasSeoScoreFeature,
    };
  },
  data() {
    return {
      saving: false,
      editing: false,
      gridKey: 0,
    }
  },
  computed: {
    ...mapState('user', ['user']),
    ...mapState('dashboard', [
      'activeWebsite',
      'uuid'
    ]),
    userName() {
      if (this.user) {
        if (this.user.name.trim()) {
          const firstName = this.user.name.trim().split(' ')[0];
          return ` ${firstName}`;
        }
      }

      return '';
    },
    showNewTerms() {
        return this.user
            && this.user.permissions.organisation_permission === 'EDIT'
            && this.user.organisation.requires_tos_acceptation
    },
    showWebsiteCancellingWarning() {
      return this.user
          && this.activeWebsite
          && this.user.permissions.organisation_permission === 'EDIT'
          && this.user.organisation.is_merchant_user === false
          && this.activeWebsite.subscription_status === 'CANCELLING'
    },
    websiteEndDateFormatted() {
      return moment(this.activeWebsite.subscription_status_datetime).format('Do MMMM YYYY')
    },
  },
  watch: {
    activeWebsite: {
      handler() {
        this.getTrafficData(this.activeWebsite.id)
      },
    },
  },
  mounted() {
    this.getUser()
      .then(() => {
        this.setActiveWebsite(this.user.active_website);
        this.getCountryFlags();
        this.getLayout();
        this.getCustomWidgets();
        this.getCompetitors();
        this.getGMBLocations();
      });
  },
  methods: {
    ...mapActions({
      getUser: 'user/getUser',
      getCountryFlags: 'dashboard/getCountryFlags',
      getLayout: 'dashboard/getLayout',
      openAddWidgetModal: 'dashboard/openAddWidgetModal',
      openMyWidgetsModal: 'dashboard/openMyWidgetsModal',
      saveDashLayout: 'dashboard/saveLayoutRequest',
      getCustomWidgets: 'dashboard/getCustomWidgets',
      getTrafficData: 'dashboard/getTrafficData',
      getGMBLocations: 'dashboard/getGMBLocations',
      getCompetitors: 'lookups/getCompetitors',
    }),
    ...mapMutations({
      setActiveWebsite: 'dashboard/setActiveWebsite',
    }),
    enableEditing() {
      this.editing = true;
      this.gridKey++;
    },
    saveLayout() {
      this.saving = true;
      this.saveDashLayout().then(() => {
        this.gridKey++;
        this.saving = false;
        this.editing = false;
      });
    },
    cancelEditing() {
      this.gridKey++;
      this.getTrafficData(this.activeWebsite.id)
      this.editing = false;
    },
    getSharableLink() {
      let url = new URL(window.location.href);
      navigator.clipboard.writeText(`${url.host}/dashboard/${this.uuid}`);

      this.SweetToast.fire({
        icon: 'success',
        title: 'Url copied to clipboard'
      });
    }
  },

}
</script>

<style scoped>
.dash_header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 1rem;
  background: #f4f4f4;
}

.dash_header :first-child {
  flex-grow: 1;
}

.dash_toolbar {
  margin-bottom: 1rem;
}

.dash_toolbar button {
  margin: 0;
}

.editing_layout {
  background: red;
  border-radius: 10px;
  padding: 0.5rem 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 18px;
  position: sticky;
  top: 65px;
  z-index: 11;
}

.editing_layout button {
  margin: 0;
  margin-left: 0.5rem;
}
</style>
